// extracted by mini-css-extract-plugin
export default {"hintList":"SupportTicketInfo_hintList__Q4Nk9"};